import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import styles from './RatingSubmitted.module.scss';
import { ChatbotWidgetContext } from 'components/ChatbotWidget/utils/ChatbotWidgetContext';
import { View } from 'components/ChatbotWidget/constants/view';
import { Typography, Icon } from 'gd-design-library';
import { Button } from 'components/baseComponents/Button';

const cx = classNames.bind(styles);

const CN = 'rating-submitted';

export const RatingSubmitted = (): React.ReactElement => {
  const { setView } = useContext(ChatbotWidgetContext);

  return (
    <div className={ cx(CN) }>
      <div>
        <Typography align='center' variant='h4'>Thank you!</Typography>
        <Typography align='center'>We appreciate your feedback</Typography>
      </div>
      <Icon name='check' width={ 100 } height={ 100 } />
      <Button variant='primary' onClick={ (): void => setView(View.SELECT_CONTACT_OPTION) }>
        Start a New Conversation
      </Button>
    </div>
  );
};
